import {
  MockHook,
  useSnackbarNotification,
  useUser,
} from '@jupiterone/jupiter-web-toolkit';
import { useDebouncedCallback } from 'use-debounce';
import { ChangeEvent, useEffect, useState } from 'react';

const useUserProfilePageLogic = () => {
  const notification = useSnackbarNotification();
  const { updateProfileName, user, loading } = useUser();
  const [profileName, setProfileName] = useState<string>('');

  useEffect(() => {
    if (loading || !user) {
      return;
    }
    if (!profileName) {
      setProfileName(user.profile.name || user.id);
    }
  }, [user, loading]);

  const [saveProfileName] = useDebouncedCallback((debouncedValue: string) => {
    if (!debouncedValue) {
      return;
    }
    updateProfileName(debouncedValue).catch((error: any) => {
      notification.error({
        error,
        message: error.message,
      });
    });
  }, 500);

  const handleNameChange = (e: ChangeEvent<HTMLInputElement>) => {
    const name = e.target.value;
    setProfileName(name);
    saveProfileName(name);
  };

  return {
    profileName,
    email: user?.profile.email,
    handleNameChange,
  };
};

export type UserProfilePageComponentProps = ReturnType<
  typeof useUserProfilePageLogic
>;
export const MOCK_USER_PROFILE_PAGE_PROPS: UserProfilePageComponentProps = {
  profileName: 'User Name',
  email: 'user@email.com',
  handleNameChange: MockHook.mockFunction,
};
export default MockHook.useMockHook(
  useUserProfilePageLogic,
  MOCK_USER_PROFILE_PAGE_PROPS
);
